import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { AppProvider } from "./context/AppContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import DashboardLayout from "./components/DashboardLayout";

// Marketing / tool pages
import Home from "./pages/Home";
import Tools from "./pages/Tools";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import CompoundInterest from "./pages/calculators/CompoundInterest";
import SalaryCalculator from "./pages/calculators/SalaryCalculator";
import ISACalculator from "./pages/calculators/ISACalculator";
import EmergencyFund from "./pages/calculators/EmergencyFund";
import CostOfWaiting from "./pages/calculators/CostOfWaiting";
import BudgetCalculator from "./pages/calculators/BudgetCalculator";
import FIRECalculator from "./pages/calculators/FIRECalculator";
import BudgetPro from "./pages/BudgetPro";
import Contact from "./pages/Contact";

// Dashboard pages
import DashboardHome from "./pages/dashboard/Dashboard";
import BudgetPlanner from "./pages/dashboard/BudgetPlanner";
import NetWorth from "./pages/dashboard/NetWorth";
import SubscriptionAudit from "./pages/dashboard/SubscriptionAudit";
import YouVsAverage from "./pages/dashboard/YouVsAverage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        {/*
          AuthProvider wraps everything so all components can call useAuth().
          AppProvider is inside AuthProvider so it can call useAuth() to get
          the logged-in user and sync data to Supabase.
        */}
        <AuthProvider>
          <AppProvider>
            <Routes>
              {/* ── Auth ── */}
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />

              {/* ── Budget Pro Landing Page ── */}
              <Route path="/budget-pro" element={<BudgetPro />} />

              {/* ── Public marketing / tools site ── */}
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/tools" element={<Tools />} />
                <Route path="/tools/compound-interest" element={<CompoundInterest />} />
                <Route path="/tools/salary-calculator" element={<SalaryCalculator />} />
                <Route path="/tools/isa-calculator" element={<ISACalculator />} />
                <Route path="/tools/emergency-fund" element={<EmergencyFund />} />
                <Route path="/tools/cost-of-waiting" element={<CostOfWaiting />} />
                <Route path="/tools/budget-calculator" element={<BudgetCalculator />} />
                <Route path="/tools/fire-calculator" element={<FIRECalculator />} />
                <Route path="/contact" element={<Contact />} />
              </Route>

              {/* ── Protected dashboard (requires session) ── */}
              <Route element={<ProtectedRoute />}>
                <Route element={<DashboardLayout />}>
                  <Route path="/dashboard" element={<DashboardHome />} />
                  <Route path="/dashboard/budget" element={<BudgetPlanner />} />
                  <Route path="/dashboard/net-worth" element={<NetWorth />} />
                  <Route path="/dashboard/subscriptions" element={<SubscriptionAudit />} />
                  <Route path="/dashboard/you-vs-average" element={<YouVsAverage />} />
                </Route>
              </Route>
            </Routes>
          </AppProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
